/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the DailyMetricsFreshnessResponse interface.
 */
export function instanceOfDailyMetricsFreshnessResponse(value) {
    if (!('alertThresholdHours' in value) || value['alertThresholdHours'] === undefined)
        return false;
    if (!('alerted' in value) || value['alerted'] === undefined)
        return false;
    if (!('checkedAt' in value) || value['checkedAt'] === undefined)
        return false;
    if (!('daysWithAnyDoc' in value) || value['daysWithAnyDoc'] === undefined)
        return false;
    if (!('hoursSinceLastWrite' in value) || value['hoursSinceLastWrite'] === undefined)
        return false;
    if (!('lookbackDays' in value) || value['lookbackDays'] === undefined)
        return false;
    if (!('trafficSignal' in value) || value['trafficSignal'] === undefined)
        return false;
    return true;
}
export function DailyMetricsFreshnessResponseFromJSON(json) {
    return DailyMetricsFreshnessResponseFromJSONTyped(json, false);
}
export function DailyMetricsFreshnessResponseFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'alertThresholdHours': json['alertThresholdHours'],
        'alerted': json['alerted'],
        'checkedAt': json['checkedAt'],
        'daysWithAnyDoc': json['daysWithAnyDoc'],
        'hoursSinceLastWrite': json['hoursSinceLastWrite'],
        'lookbackDays': json['lookbackDays'],
        'trafficSignal': json['trafficSignal'],
    };
}
export function DailyMetricsFreshnessResponseToJSON(json) {
    return DailyMetricsFreshnessResponseToJSONTyped(json, false);
}
export function DailyMetricsFreshnessResponseToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'alertThresholdHours': value['alertThresholdHours'],
        'alerted': value['alerted'],
        'checkedAt': value['checkedAt'],
        'daysWithAnyDoc': value['daysWithAnyDoc'],
        'hoursSinceLastWrite': value['hoursSinceLastWrite'],
        'lookbackDays': value['lookbackDays'],
        'trafficSignal': value['trafficSignal'],
    };
}
